import script from "./NumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumberInput.vue?vue&type=script&setup=true&lang=ts"

import "./NumberInput.vue?vue&type=style&index=0&id=15d63bb3&lang=css"

const __exports__ = script;

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
